<template>
  <div class="row" v-if="ultima_dec">
    <app-modal id="modal" :title="modalTitle" :comp="modalComponent" v-model="rate" :size="modalSize" :hideClose="false"></app-modal>
    <div class="col-md-10 col-md-offset-2 container-fluid">
      <div class="card">
        <div class="card-content text-center alert-success">
          <h3>Declaración Enviada Exitosamente</h3><br />
          <v-btn text color="teal darken-2" @click.prevent="cerrarSesion" class="">
            No olvides <u class="pl-2">Cerrar Sesión</u>
          </v-btn>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-md-offset-3 container-fluid text-center">
      <button type="button" class="btn btn-wd btn-info" @click="descarga">
        <span class="btn-label">
          <i class="fa fa-save"></i>
        </span>
        Descargar declaración
      </button>
    </div>
    <div class="col-md-6 col-md-offset-3 container-fluid text-center">
      <button type="button" class="btn btn-wd btn-info" @click="descargaAcuse">
        <span class="btn-label">
          <i class="fa fa-save"></i>
        </span>
        Descargar Acuse
      </button>
    </div>
    <!-- <div class="col-md-6 col-md-offset-3 container-fluid text-center">
      <button type="button" class="btn btn-wd btn-info" @click="test(rate)">
        <span class="btn-label">
          <i class="fa fa-save"></i>
        </span>
        test
      </button>
    </div> -->
  </div>
  <div class="row" v-else>
    <div class="col-md-10 col-md-offset-2 container-fluid">
      <div class="card">
        <div class="card-content text-center alert-warning">
          <h3>No cuenta con declaraciones realizadas.</h3><br />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {
    Table,
    TableColumn
  } from 'element-ui'
  Vue.use(Table)
  Vue.use(TableColumn)
  export default {
    data() {
      return {
        ultima_dec: null,
        ip_id: null,
        fecha: '',
        hora: '',
        dpersonales: [],
        encargo: null,
        intereses: null,
        activos: null,
        sueldos: null,
        rate: {
          rate: 0,
          observaciones: ''
        }
      }
    },
    created() {
      this.ip_id = this.getKey('uid');

      this.$http.get("historicolst/" + this.ip_id).then(
        response => {
          if (response.data.response.length > 0) {
            this.ultima_dec = true;
          } else {
            this.ultima_dec = false;
          }

        }, error => {
          this.ultima_dec = false;
          this.Err(error);
        }
      );

      this.checkPermissions();
    },
    methods: {
      cerrarSesion() {
        localStorage.clear();
        eventBus.$emit('cerro');
        this.$router.push('/login');
      },
      checkPermissions() {
        //  && this.getKey('status_dec') == 1
        if (!(this.getKey('role') == 0)) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();
        }
      },
      descarga(id) {
        id = 20514;
        /* const token = localStorage.getItem('app-token-declaranet');
          const auth = 'Bearer ' + (token ? token.hash : "");

          var url = this.$apiUrl + 'getDeclaracion/pdf/' + this.ip_id;
          window.open(url, '_blank');
          */
        this.$http.get(this.$apiUrl + 'getDeclaracion2/pdf/' + 1 + "/" + this.ip_id, {
          responseType: 'arraybuffer'
        }).then(
          //this.$http.get('getDeclaracion/pdf/' +this.ip_id+"/1").then(
          response => {
            this.downloadFile(response, 'Declaración')
          },
          error => {
            this.StepError(error);
          }
        )

      },
      descargaAcuse() {

        const token = localStorage.getItem('app-token-declaranet');
        const auth = 'Bearer ' + (token ? token.hash : "");

        var url = this.$apiUrl + 'pdf/' + this.ip_id;
        window.open(url, '_blank');
        //window.open('/declaranet/public/api/pdf/'+this.ip_id ,'_blank');

      },
      downloadFile(response, filename) {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([response.body], {
          type: 'application/pdf'
        })

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob)
          return
        }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob)
        var link = document.createElement('a')
        link.href = data
        link.download = filename + '.pdf'
        link.click()
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data)
        }, 100)
      },
      test(item) {
        this.modalTitle = "Es importante tu opinión";
        this.modalComponent = "rating";
        this.Modal("#modal");

      },
    }
  }

</script>
<style>
  img.resize {
    max-width: 40% !important;
    max-height: 40% !important;
  }

  .categoria {
    font-weight: bold !important;
  }

  .datos {
    margin-block-start: 0px !important;
    margin-block-end: 0px !important;
  }

  .fechap::first-letter {
    text-transform: uppercase;
  }

  .fechap {
    font-weight: bold;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Enviada.vue